module.exports = __webpack_public_path__ + "pc/img/body_basic 5.062f8f4d.jpg";